// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_POST = "P\u0159idej p\u0159\u00edsp\u011bvek";
export const ADD_RECIPE = "Pod\u011blte se o sv\u016fj recept";
export const CREATE_ALBUM = "Vytvo\u0159 album";
export const DRAFTS = "Rozepsan\u00e9 \u010dl\u00e1nky";
export const PROFILE_OF_USER = "Profil u\u017eivatelky";
export const USER_LIKE = "P\u0159idej k obl\u00edben\u00fdm";
export const USER_UNLIKE = "Odeber z obl\u00edben\u00fdch";
export const WRITE_ARTICLE = "Napi\u0161 \u010dl\u00e1nek";
export const WRITE_SHORT_MESSAGE = "Napi\u0161 kr\u00e1tkou zpr\u00e1vu";
